import ls from '../../utils/localStorage.js';
import { getExpert } from '../../api/api';

const state = {
  expert_list: ''
}

const mutations = {
    UPDATE_EXPERT_LIST(state,payload) {
        state.expert_list = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {

    // 获取门店列表
    requestExpert(store,item) {
        getExpert(item.city).then( data => {
            item.thit.loading = true;
            store.commit('UPDATE_EXPERT_LIST',JSON.stringify(data));
        }).catch(error => {
            
        })
    }
    
}

export default {
    state,
    mutations,
    getters,
    actions
}
